export const iconFontAwesomeAccessibilityHands = (
	<i className="fa-solid fa-hands"></i>
);
